export const flattenOperator = (formData, queryObject) => ({
    operation: 'flatten',
});
//# sourceMappingURL=flattenOperator.js.map